/// <amd-module name="SuiteCommerce.Blog.Common.Configuration"/>
define("SuiteCommerce.Blog.Common.Configuration", ["require", "exports", "Utils"], function (require, exports, Utils_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var environment = null;
    var Configuration = /** @class */ (function () {
        function Configuration() {
        }
        Object.defineProperty(Configuration, "environment", {
            set: function (environmentComponent) {
                environment = environmentComponent;
            },
            enumerable: true,
            configurable: true
        });
        Configuration.get = function (key) {
            if (environment) {
                return environment.getConfig(key);
            }
            console.error('Please set the Environment Component in the Configuration.');
            return null;
        };
        Configuration.translate = function (text) {
            return Utils_1.translate(text);
        };
        Object.defineProperty(Configuration, "siteId", {
            get: function () {
                if (environment) {
                    return environment.getSiteSetting('siteid');
                }
                return null;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Configuration, "readMoreLabel", {
            get: function () {
                return this.get('blog.readMoreLabel');
            },
            enumerable: true,
            configurable: true
        });
        Configuration.isRunningInSEO = function () {
            return environment.isPageGenerator();
        };
        Object.defineProperty(Configuration, "isEnabledJSONLd", {
            get: function () {
                return this.get('structureddatamarkup.type') === 'JSON-LD';
            },
            enumerable: true,
            configurable: true
        });
        return Configuration;
    }());
    exports.Configuration = Configuration;
});
